export default __webpack_public_path__ + "static/media/bank4.7be35414.PNG";